import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '../../../../../common/modal/Modal';
import TicketReassignmentBasicInformationResource from './resource/TicketReassignmentBasicInformationResource';
import EditTicketReassignmentForm from './EditTicketReassignmentForm';
import {
  getTicketReassignments,
  putTicketReassignment,
} from '../../../../../../actions/reservation/TicketReassignment';
import { DEFAULT_QUERY_GET_ALL } from '../../../../../../config/queries';
import {
  TICKET_REASSINGMENT_ACCEPT_MERGE,
  TICKET_REASSINGMENT_NEGOTIATION,
  TICKET_REASSINGMENT_RETURN_TYPE,
} from '../../../../../../config/constants';

const TicketReassignmentModal = ({
  open,
  mode,
  data,
  onClose,
  dispatchPutTicketReassignment,
  dispatchGetTicketReassignments,
  itineraryId,
}) => {
  if (!open) return null;

  const title = mode === 'edit' ? 'Editar reasignación' : 'Ver detalles';

  const handleBackdropClick = () => {
    if (onClose) onClose();
  };

  const handleCancel = () => {
    if (onClose) onClose();
  };

  const handleSubmit = async (formValues) => {
    const newFormValues = {
      acceptMerge: formValues.acceptMerge ? formValues.acceptMerge.value : null,
      negotiation: formValues.negotiation ? formValues.negotiation.value : null,
      refundType: formValues.refundType ? formValues.refundType.value : null,
      comment: formValues.comment,
    };

    const success = await dispatchPutTicketReassignment(data.id, newFormValues);

    if (success) {
      dispatchGetTicketReassignments({
        ...DEFAULT_QUERY_GET_ALL,
        query: [`previousItineraryId:${itineraryId}`],
      });
      onClose();
    }
  };

  const modalBody = useMemo(() => {
    if (!data || !data.item) {
      return <div>-</div>;
    }

    if (mode === 'edit') {
      return (
        <EditTicketReassignmentForm
          initialValues={{
            acceptMerge:
              TICKET_REASSINGMENT_ACCEPT_MERGE[data.item.acceptMerge],
            negotiation: TICKET_REASSINGMENT_NEGOTIATION[data.item.negotiation],
            refundType: TICKET_REASSINGMENT_RETURN_TYPE[data.item.refundType],
            comment: data.item.comment,
          }}
          onCancel={handleCancel}
          onSubmit={handleSubmit}
        />
      );
    }

    return <TicketReassignmentBasicInformationResource {...data.item} />;
  }, [data, mode]);

  return (
    <Modal
      show={open}
      title={title}
      body={modalBody}
      onClickClose={handleBackdropClick}
    />
  );
};

const mapDispatchToProps = {
  dispatchPutTicketReassignment: putTicketReassignment,
  dispatchGetTicketReassignments: getTicketReassignments,
};

TicketReassignmentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['view', 'edit']),
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // eslint-disable-next-line react/forbid-prop-types
    item: PropTypes.object,
  }),
  onClose: PropTypes.func.isRequired,
  dispatchPutTicketReassignment: PropTypes.func.isRequired,
  dispatchGetTicketReassignments: PropTypes.func.isRequired,
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TicketReassignmentModal.defaultProps = {
  mode: 'view',
  data: null,
  itineraryId: null,
};

export default connect(null, mapDispatchToProps)(TicketReassignmentModal);
